import React from 'react';
import PropTypes from 'prop-types';

const LogOut = ({ size, fill, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M3 3C2.44772 3 2 3.44772 2 4V16C2 16.5523 2.44772 17 3 17C3.55228 17 4 16.5523 4 16V4C4 3.44772 3.55228 3 3 3Z"
      fill={fill}
    />
    <path
      d="M13.2929 12.2929C12.9024 12.6834 12.9024 13.3166 13.2929 13.7071C13.6834 14.0976 14.3166 14.0976 14.7071 13.7071L17.7071 10.7071C17.8946 10.5196 18 10.2652 18 10C18 9.73478 17.8946 9.48043 17.7071 9.29289L14.7071 6.29289C14.3166 5.90237 13.6834 5.90237 13.2929 6.29289C12.9024 6.68342 12.9024 7.31658 13.2929 7.70711L14.5858 9L7 9C6.44771 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H14.5858L13.2929 12.2929Z"
      fill={fill}
    />
  </svg>
);

LogOut.propTypes = {
  size: PropTypes.number,
  fill: PropTypes.string,
};

LogOut.defaultProps = {
  size: 24,
  fill: '#4d535e',
};

export default LogOut;




// WEBPACK FOOTER //
// ./src/client/Components/Icons/LogOut.js